import React from "react";
import {Box, Typography} from "@material-ui/core";

const boxProps = {
  bgcolor: "background.paper",
  m: 1,
  borderColor: "text.primary",
};

export default function PositionTacticSummaryBox({ scalingIn, addToWinner }) {
  let scalingInText = "";
  let addToWinnerText = "";
  if (scalingIn !== undefined) {
    scalingInText = (
      <>
          <b>scaling in </b>: qtyBasisValues: {JSON.stringify(scalingIn.quantityBasisValues)}.
        breakPrices: {JSON.stringify(scalingIn.breakPrices)}
        <br></br>
      </>
    );
  }
  if (addToWinner !== undefined) {
    addToWinnerText = (
      <>
          <b>add to winner</b>: qtyBasisValues: {JSON.stringify(addToWinner.quantityBasisValues)}.
        breakPrices: {JSON.stringify(addToWinner.breakPrices)}{" "}
      </>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      border={1}
      {...boxProps}
    >
        <Typography style={{fontSize: 10}}>
      {scalingInText}
      {addToWinnerText}
        </Typography>
    </Box>
  );
}
